import { type SliderNotches, type SliderTooltipNotch } from "../../SliderBase";
import { useIsTooltipNotches } from "..";
import { safeTooltipNotches } from "./safeTooltipNotches";

const safeNotches = (
  minValue: number,
  maxValue: number,
  notches: number[]
): number[] => {
  const sorted = notches.sort((a, b) => a - b);
  const rangeSafe = sorted.filter(
    (notchValue) => notchValue > minValue && notchValue < maxValue
  );

  // fast de-duping
  const unique = Array.from(new Set(rangeSafe));
  return unique;
};

export const useSafeSliderNotches = (
  minValue: number,
  maxValue: number,
  notches: SliderNotches
): SliderNotches => {
  if (!notches || !notches.length) return undefined;

  return useIsTooltipNotches(notches)
    ? safeTooltipNotches(minValue, maxValue, notches as SliderTooltipNotch[])
    : safeNotches(minValue, maxValue, notches as number[]);
};
